import { Pipe, PipeTransform } from '@angular/core';

// this pipe will call the function only once instead of calling it each time change detection happens
@Pipe({
  name: 'schemaTitle',
  pure: true
})
export class SchemaTitlePipe implements PipeTransform {
  transform(schemaName: string): string {
    return schemaName.replace('Schema', '').toUpperCase();
  }
}
